import { apiErrorMessage } from './ApiError';
import { LocationModel } from '@app/interfaces/location';
import { axiosApi } from './axios.api';

const url = `/api/locations`;

export const getLocationsApi = async (): Promise<LocationModel[] | undefined> => {
  try {
    const response = await axiosApi.get<LocationModel[]>(url);
    return response.data;

  } catch (e: any) {
    throw new Error(e);
  }
};

export const createLocationApi = async (data: LocationModel) => {
  try {
    const response = await axiosApi.post(url, data);
    return response.data;

  } catch (e: any) {
    throw new Error(e);
  }
};

export const updateLocationApi = async (locationId: number, formData: LocationModel) => {
  try {
    const response = await axiosApi.put(`${url}/${locationId}`, formData);
    return response.data;

  } catch (e: any) {
    throw new Error(e);
  }
};

export const deleteLocationApi = async (locationId: number) => {
  try {
    const response = await axiosApi.delete(`${url}/${locationId}`);
    return response.data;

  } catch (e: any) {
    apiErrorMessage(e); // giữ lý do chặn xoá từ backend (422) thay vì 'Request failed...'
  }
};